module.exports = "/_next/static/images/bw-9145c2d2fadfb012b87b40d590c6aa5d.svg";